if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);

        this.selectors = {
          variantIdInput: 'input[name="id"]',
        };
        this.sectionId = this.dataset.section;
        this.container = this.closest(`#ProductInfo-${this.sectionId}`);
        
      }

      connectedCallback() {
        this.getVariantData();
        const variantIdInput = this.container && this.container.querySelector(this.selectors.variantIdInput);
        this.currentVariant = variantIdInput
          ? this.variantData.find((variant) => variant.id === Number(variantIdInput.value))
          : false;

        if (this.currentVariant) {
          this.updateMedia();
        }
        
      }

      onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updateSelectedSwatchValue(event);
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();
         
        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();

          
        } else {
          this.updateURL();
          this.updateVariantInput();
          this.updateMedia();
          this.renderProductInfo();
          this.updateShareUrl();

          

          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: {
                variant: this.currentVariant,
              },
            })
          );
        }


        //by Grace Art
        //console.log(this.options[0]);
        
        //console.log(JSON.stringify(this, null, 4));
        //this.updateVariantDetail(event); 
        
      }

      //by thewallart
      updateVariantDetail(currentOptionSelected){ 

        
        
        
        currentOptionSelected = currentOptionSelected.toLowerCase();

        // show "Your selected Custom Frame" if CUSTOM Option "selected"
        // thewallart: find the CUSTOM frame radio by value, not by the theme's section id
        // (the id changes whenever the theme is duplicated).
        var customRadio = document.querySelector('variant-selects input[type="radio"][value="custom"]');
        var customBox = document.querySelector('#idSelectedCustomFrameFromCustomer');
        if (customBox) customBox.style.display = (customRadio && customRadio.checked) ? 'block' : 'none';
        
        //console.log("[");
        console.log(currentOptionSelected);
        //console.log(this.options[0].toLowerCase());
        //console.log("]");
        //if(this.options[0].toLowerCase() === "framed canvas"){
        if(currentOptionSelected === "framed canvas"){
          if(document.querySelector('#Id_Paper_Black') !== null)
            document.querySelector('#Id_Paper_Black').style.display = 'none';
          if(document.querySelector('#Id_Paper_White') !== null)
            document.querySelector('#Id_Paper_White').style.display = 'none';
          if(document.querySelector('#Id_Paper_Timer') !== null)
            document.querySelector('#Id_Paper_Timer').style.display = 'none';

          if(document.querySelector('#Id_Floating_Black') !== null)
            document.querySelector('#Id_Floating_Black').style.display = 'block';
          if(document.querySelector('#Id_Floating_Timber') !== null)
            document.querySelector('#Id_Floating_Timber').style.display = 'block';
          if(document.querySelector('#Id_Floating_White') !== null)
            document.querySelector('#Id_Floating_White').style.display = 'block';
          if(document.querySelector('#Id_Floating_Gold') !== null)
            document.querySelector('#Id_Floating_Gold').style.display = 'block';
          
          if(document.querySelector('#Id_Stretched_Canvas') !== null)
            document.querySelector('#Id_Stretched_Canvas').style.display = 'none';
          if(document.querySelector('#Id_Custom_Canvas') !== null)
            // UnComment line below if want to showw "Custom Option"?            
            //document.querySelector('#Id_Custom_Canvas').style.display = 'block';

          if(document.querySelector('#Id_AddWhiteBorder') !== null)
            document.querySelector('#Id_AddWhiteBorder').style.display = 'none';

          //if(document.querySelector('#Id_SelectCustomFrame') !== null)
           // document.querySelector('#Id_SelectCustomFrame').style.display = 'block';

          // Click Event
          if(document.querySelector('#Id_Size_Variant_50x50') !== null)            
            document.getElementById('Id_Size_Variant_50x50').click();
          else if(document.querySelector('#Id_Size_Variant_50x70') !== null)            
            document.getElementById('Id_Size_Variant_50x70').click();
          else if(document.querySelector('#Id_Size_Variant_70x50') !== null)            
            document.getElementById('Id_Size_Variant_70x50').click();
          else if(document.querySelector('#Id_Size_Variant_50x100') !== null)             
            document.getElementById('Id_Size_Variant_50x100').click();
          else if(document.querySelector('#Id_Size_Variant_100x50') !== null)            
            document.getElementById('Id_Size_Variant_100x50').click();

          if(document.querySelector('#Id_Floating_Black') !== null)            
            document.getElementById('Id_Floating_Black').click();

          // Show sizes belong to                    
          this.showSizeBelongTo();
          
    
          console.log(this.options[0]);
        }
        else if (currentOptionSelected === "stretched canvas"){
         if(document.querySelector('#Id_Paper_Black') !== null)
            document.querySelector('#Id_Paper_Black').style.display = 'none';
          if(document.querySelector('#Id_Paper_White') !== null)
            document.querySelector('#Id_Paper_White').style.display = 'none';
          if(document.querySelector('#Id_Paper_Timer') !== null)
            document.querySelector('#Id_Paper_Timer').style.display = 'none';

          if(document.querySelector('#Id_Floating_Black') !== null)
            document.querySelector('#Id_Floating_Black').style.display = 'none';
          if(document.querySelector('#Id_Floating_Timber') !== null)
            document.querySelector('#Id_Floating_Timber').style.display = 'none';
          if(document.querySelector('#Id_Floating_White') !== null)
            document.querySelector('#Id_Floating_White').style.display = 'none';
          if(document.querySelector('#Id_Floating_Gold') !== null)
            document.querySelector('#Id_Floating_Gold').style.display = 'none';
          if(document.querySelector('#Id_Stretched_Canvas') !== null)
            document.querySelector('#Id_Stretched_Canvas').style.display = 'block';
          if(document.querySelector('#Id_Custom_Canvas') !== null)
            document.querySelector('#Id_Custom_Canvas').style.display = 'none';

          if(document.querySelector('#Id_AddWhiteBorder') !== null)
            document.querySelector('#Id_AddWhiteBorder').style.display = 'none';

          //if(document.querySelector('#Id_SelectCustomFrame') !== null)
          //  document.querySelector('#Id_SelectCustomFrame').style.display = 'none';

          // Click Event
          if(document.querySelector('#Id_Size_Variant_50x50') !== null)            
            document.getElementById('Id_Size_Variant_50x50').click();
          else if(document.querySelector('#Id_Size_Variant_50x70') !== null)            
            document.getElementById('Id_Size_Variant_50x70').click();
          else if(document.querySelector('#Id_Size_Variant_70x50') !== null)            
            document.getElementById('Id_Size_Variant_70x50').click();
          else if(document.querySelector('#Id_Size_Variant_50x100') !== null)             
            document.getElementById('Id_Size_Variant_50x100').click();
          else if(document.querySelector('#Id_Size_Variant_100x50') !== null)            
            document.getElementById('Id_Size_Variant_100x50').click();

          if(document.querySelector('#Id_Stretched_Canvas') !== null)
            document.getElementById('Id_Stretched_Canvas').click();

           // Show sizes belong to                    
          this.showSizeBelongTo();
          
          console.log(this.options[0]);
        }else if (currentOptionSelected == "framed poster"){
          if(document.querySelector('#Id_Paper_Black') !== null)
            document.querySelector('#Id_Paper_Black').style.display = 'block';
          if(document.querySelector('#Id_Paper_White') !== null)
            document.querySelector('#Id_Paper_White').style.display = 'block';
          if(document.querySelector('#Id_Paper_Timer') !== null)
            document.querySelector('#Id_Paper_Timer').style.display = 'block';

          if(document.querySelector('#Id_Floating_Black') !== null)
            document.querySelector('#Id_Floating_Black').style.display = 'none';
          if(document.querySelector('#Id_Floating_Timber') !== null)          
            document.querySelector('#Id_Floating_Timber').style.display = 'none';
          if(document.querySelector('#Id_Floating_White') !== null)
            document.querySelector('#Id_Floating_White').style.display = 'none';
          if(document.querySelector('#Id_Floating_Gold') !== null)
            document.querySelector('#Id_Floating_Gold').style.display = 'none';
          if(document.querySelector('#Id_Stretched_Canvas') !== null)
            document.querySelector('#Id_Stretched_Canvas').style.display = 'none';
          if(document.querySelector('#Id_Custom_Canvas') !== null){
            // UnComment line below if want to showw "Custom Option"?
            // document.querySelector('#Id_Custom_Canvas').style.display = 'block';
          }

          if(document.querySelector('#Id_AddWhiteBorder') !== null)
            document.querySelector('#Id_AddWhiteBorder').style.display = 'block';

          //if(document.querySelector('#Id_SelectCustomFrame') !== null)
          //  document.querySelector('#Id_SelectCustomFrame').style.display = 'block';

          // Click Event
          if(document.querySelector('#Id_Size_Variant_50x50') !== null)            
            document.getElementById('Id_Size_Variant_50x50').click();
          else if(document.querySelector('#Id_Size_Variant_50x70') !== null)            
            document.getElementById('Id_Size_Variant_50x70').click();
          else if(document.querySelector('#Id_Size_Variant_70x50') !== null)            
            document.getElementById('Id_Size_Variant_70x50').click();
          else if(document.querySelector('#Id_Size_Variant_50x100') !== null)             
            document.getElementById('Id_Size_Variant_50x100').click();
          else if(document.querySelector('#Id_Size_Variant_100x50') !== null)            
            document.getElementById('Id_Size_Variant_100x50').click();

          if(document.querySelector('#Id_Paper_Black') !== null)
            document.getElementById('Id_Paper_Black').click();

          //----- Hide sizes not belong to   
          this.hideSizeNotBelongTo();         
          
          console.log(this.options[0]);
        }else if (currentOptionSelected == "custom"){

          // show popup to select custom size
          //document.getElementById('Id_ButtonSelectCustomFrame').click();
          // show text "Your selected Custom Frame:"
          //if(document.querySelector('#idSelectedCustomFrameFromCustomer') !== null)
          //  document.querySelector('#idSelectedCustomFrameFromCustomer').style.display = 'block';
          
          console.log(this.options[0]);
        }
        
         // const N_Canvas = document.querySelector ('lable[name="N_Canvas"]');
         //const N_Paper = document.querySelector ('lable[name="N_Paper"]');
         //const Id_Paper_Black = document.querySelector('#Id_Paper_Black');
         //Id_Paper_Black.style.display = 'none';
        
        //const N_Paper = document.querySelectorAll('[label="N_Paper"]');
         //N_Paper.style.display = 'none';
         
      }

      showSizeBelongTo(){
        if(typeof document.querySelectorAll('[id^="Id_Size_Variant_140x140"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_140x140"]')[0].style.display = 'flex';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_160x160"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_160x160"]')[0].style.display = 'flex';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_200x200"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_200x200"]')[0].style.display = 'flex';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_240x240"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_240x240"]')[0].style.display = 'flex';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_270x270"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_270x270"]')[0].style.display = 'flex';
          
          // Scale 1:2
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_320x160"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_320x160"]')[0].style.display = 'flex';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_400x200"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_400x200"]')[0].style.display = 'flex';
         
          // Scale 2:1
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_160x320"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_160x320"]')[0].style.display = 'flex';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_200x400"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_200x400"]')[0].style.display = 'flex';
         
          // Scale 2:3
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_140x210"]')[0] !== "undefined")          
             document.querySelectorAll('[id^="Id_Size_Variant_140x210"]')[0].style.display = 'flex';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_160x240"]')[0] !== "undefined") 
             document.querySelectorAll('[id^="Id_Size_Variant_160x240"]')[0].style.display = 'flex';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_180x270"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_180x270"]')[0].style.display = 'flex';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_200x300"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_200x300"]')[0].style.display = 'flex';
          
          // Scale 3:2
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_210x140"]')[0] !== "undefined")          
             document.querySelectorAll('[id^="Id_Size_Variant_210x140"]')[0].style.display = 'flex';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_240x160"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_240x160"]')[0].style.display = 'flex';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_270x180"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_270x180"]')[0].style.display = 'flex';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_300x200"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_300x200"]')[0].style.display = 'flex';
          
      }

      hideSizeNotBelongTo(){
     // Scale 1:1
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_140x140"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_140x140"]')[0].style.display = 'none';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_160x160"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_160x160"]')[0].style.display = 'none';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_200x200"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_200x200"]')[0].style.display = 'none';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_240x240"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_240x240"]')[0].style.display = 'none';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_270x270"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_270x270"]')[0].style.display = 'none';
          
          // Scale 1:2
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_320x160"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_320x160"]')[0].style.display = 'none';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_400x200"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_400x200"]')[0].style.display = 'none';
         
          // Scale 2:1
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_160x320"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_160x320"]')[0].style.display = 'none';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_200x400"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_200x400"]')[0].style.display = 'none';
         
          // Scale 2:3
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_140x210"]')[0] !== "undefined")          
             document.querySelectorAll('[id^="Id_Size_Variant_140x210"]')[0].style.display = 'none';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_160x240"]')[0] !== "undefined") 
             document.querySelectorAll('[id^="Id_Size_Variant_160x240"]')[0].style.display = 'none';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_180x270"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_180x270"]')[0].style.display = 'none';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_200x300"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_200x300"]')[0].style.display = 'none';
          
          // Scale 3:2
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_210x140"]')[0] !== "undefined")          
             document.querySelectorAll('[id^="Id_Size_Variant_210x140"]')[0].style.display = 'none';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_240x160"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_240x160"]')[0].style.display = 'none';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_270x180"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_270x180"]')[0].style.display = 'none';
          
          if(typeof document.querySelectorAll('[id^="Id_Size_Variant_300x200"]')[0] !== "undefined")
             document.querySelectorAll('[id^="Id_Size_Variant_300x200"]')[0].style.display = 'none';
          
          
      }
      
      updateOptions() {
        this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
          if (element.tagName === 'SELECT') {
            return element.value;
          }
          if (element.tagName === 'FIELDSET') {
            return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
          }
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { name, value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }


        this.updateVariantDetail(value); 

        
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        // thewallart - remove variant from URL
        //window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
      }

      updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
          (variant) => this.querySelector(':checked').value === variant.option1
        );
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
          if (index === 0) return;
          const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
          const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((element) => {
          const value = element.getAttribute('value');
          const availableElement = availableValuesList.includes(value);

          if (element.tagName === 'INPUT') {
            element.classList.toggle('disabled', !availableElement);
          } else if (element.tagName === 'OPTION') {
            element.innerText = availableElement
              ? value
              : FoxTheme.variantStrings.unavailable_with_option.replace('[value]', value);
          }
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute('available');
          pickUpAvailability.innerHTML = '';
        }
      }

      removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
      }

      updateMedia() {
        const productMedia = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (productMedia) {
          if (typeof productMedia.setActiveMedia === 'function') {
            productMedia.setActiveMedia(this.currentVariant);
          } else {
            this.timer = setInterval(() => {
              if (typeof productMedia.setActiveMedia === 'function') {
                clearInterval(this.timer);
                productMedia.setActiveMedia(this.currentVariant);
              }
            }, 100);
          }
        }
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            // Prevent unnecessary ui changes from abandoned selections.
            if (this.currentVariant.id !== requestedVariantId) return;

            let html = new DOMParser().parseFromString(responseText, 'text/html');

            // Need parse DOM from template for quick view.
            const quickView = html.querySelector('#MainProduct-quick-view__content');
            if (quickView) {
              html = quickView.content.cloneNode(true);
            }

            const priceDestination = document.getElementById(`price-${this.dataset.section}`);
            const priceSource = html.getElementById(`price-${sectionId}`);
            if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;

            const skuSource = html.getElementById(`Sku-${sectionId}`);
            const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
            if (skuSource && skuDestination) {
              skuDestination.innerHTML = skuSource.innerHTML;
              skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
            }

            const inventorySource = html.getElementById(`Inventory-${sectionId}`);
            const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
            if (inventorySource && inventoryDestination) {
              const inventoryBarSource = inventorySource.querySelector('progress-bar');
              const inventoryBarDestination = inventoryDestination.querySelector('progress-bar');

              if (inventoryBarSource && inventoryBarDestination) {
                inventoryBarSource.dataset.from = inventoryBarDestination.dataset.value;
              }

              inventoryDestination.innerHTML = inventorySource.innerHTML;
            }

            const badgesSource = html.getElementById(`Badges-${sectionId}`);
            const badgesDestination = document.getElementById(`Badges-${this.dataset.section}`);
            if (badgesSource && badgesDestination) {
              badgesDestination.innerHTML = badgesSource.innerHTML;
            }

            const price = document.getElementById(`price-${this.dataset.section}`);
            if (price) price.classList.remove('hidden');

            if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

            const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
            this.toggleAddButton(
              addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
              FoxTheme.variantStrings.soldOut
            );

            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId,
                html,
                variant: this.currentVariant,
              },
            });
          });
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = FoxTheme.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }
    }
  );
}
